module.exports = {
  address: "0x38d6B1DcD5A21f80B9544c7BbfDBbA0dDc9fb5A6",
  address_test: '',
  abi: require('./PromotionReward.abi.json')
}
